import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import './assets/css/global.css'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import * as echarts from 'echarts'
axios.defaults.baseURL = 'http://110.40.152.26:9016' // 请求跟路径
Vue.use(ElementUI)
Vue.prototype.$http = axios // axios的全局调用配置
new Vue({
  router,
  el: '#app',
  render: h => h(App)
}).$mount('#app')

Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
